import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoginService } from './login/login.service';
declare let gtag: Function;
declare let fbq: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  favIcon: HTMLLinkElement = document.querySelector('#appFavicon');
  constructor(
    private titleService: Title,
    private router: Router,
    private loginService: LoginService,
  ) {
    // this.titleService.setTitle(environment.org);
    if (this.favIcon) {
      this.favIcon.href = environment.assets.favIcon;
    }
    router.events.subscribe((y: NavigationEnd) => {
      if (y instanceof NavigationEnd) {
        // gtag('config', 'UA-{ID}', { 'page_path': y.url });
        fbq('track', 'PageView');
      }
    });
  }

  ngOnInit(): void {
    this.loginService.renewCookieExpiry();
  }
}
